import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=524ac529"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=524ac529&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports